import { ref, computed } from 'vue'
import defaultLogo from '@/assets/isbet-logo.png'
import store from '@/store'
import { getPublicSettings } from '@/services/wootdashSystemSettings'

const STORAGE_KEY  = 'isbet_custom_logo'

const customLogo = ref<string | null>(localStorage.getItem(STORAGE_KEY))
const logoLoaded = ref(false)

/**
 * Logo personalizado (Configurações Gerais › Dashboard › Logo personalizado, no WootDash —
 * substitui o custom_logo do n8n). Lido uma vez por sessão; o último valor fica no localStorage
 * pra não piscar o logo padrão na próxima abertura.
 */
export function useLogo() {
  const logoUrl       = computed(() => customLogo.value || defaultLogo)
  const hasCustomLogo = computed(() => !!customLogo.value)

  async function loadLogo(): Promise<void> {
    if (logoLoaded.value) return
    const token = store.getters.authUser?.wootdash_token
    if (!token) return
    logoLoaded.value = true
    const settings = await getPublicSettings(token)
    if (!settings) return
    customLogo.value = settings.customLogo
    try {
      if (settings.customLogo) localStorage.setItem(STORAGE_KEY, settings.customLogo)
      else localStorage.removeItem(STORAGE_KEY)
    } catch { /* storage indisponível */ }
  }

  return { logoUrl, defaultLogo, hasCustomLogo, loadLogo }
}
